import React from 'react';

import { Container, Label, Select, Option } from './quantitySelect.styles';

export interface QuantitySelectProps {
  onChange: (selectedValue: number) => void;
  options: number[];
  value: number;
}

export const QuantitySelect = ({ onChange, options, value }: QuantitySelectProps) => {
  const handleChange = (event: React.ChangeEvent) => {
    const value = Number((event.target as HTMLSelectElement).value);
    onChange(value);
  };

  return (
    <Container isDisabled={options.length === 0}>
      <Label htmlFor="quantity_select">Quantity:</Label>
      <Select
        id="quantity_select"
        name="quantity_select"
        value={value}
        onChange={(event) => handleChange(event)}
      >
        {options.map((value, index) => (
          <Option value={value} key={index}>
            {value}
          </Option>
        ))}
      </Select>
    </Container>
  );
};
